/**
 * @description Format a recurring plan/charge ISO date for display.
 * @dependencies date-fns, invoiceHelpers.parseDateSafely
 * @notes YYYY-MM-DD must go through parseDateSafely so UTC midnight
 *   does not shift the calendar day in US timezones.
 */

import { format } from 'date-fns';
import { parseDateSafely } from './invoiceHelpers';

/**
 * @param {string|null|undefined} isoDate
 * @param {string} [pattern='EEEE, MMM d, yyyy']
 * @returns {string}
 */
export default function formatChargeDate(isoDate, pattern = 'EEEE, MMM d, yyyy') {
  if (!isoDate) return '—';
  return format(parseDateSafely(isoDate), pattern);
}
